import React from 'react';
import { Controller } from 'react-hook-form';
import SelectSearch from '@alfa-retail-react/components/select-search';
import { useFormContext } from '@alfa-retail-react/components/form-hook';

import { WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { BirthPlaceFormStore } from 'app/logic/pages/order/BirthPlaceFormStore';
import { OrderFormValues } from 'app/logic/pages/order/OrderPage';
import { LocalityReference } from 'app/model/LocalityReference';
import { LocalityReferenceRenderer, PrimaryContent } from 'app/logic/address/LocalityReferenceRenderer';
import { ReferenceService } from 'app/service/ReferenceService';
import { useIsDesktop } from 'app/utils/useWindowType';
import { ValidationRules } from 'app/form/ValidationRules';

export interface BelarusBirthLocalityFormItemProps {
    /**
     * Хранилище состояния, содержадщего информацию о месте рождения пользователя.
     */
    formStore: BirthPlaceFormStore;
}

export const BelarusBirthLocalityFormItem = ({
    formStore,
}: BelarusBirthLocalityFormItemProps) => {
    const BELARUS_BIRTH_LOCALITY_FORM_ITEM_NAME = 'belarusLocality';
    const { control, handleMultipleErrors, setFieldElement } =
        useFormContext<OrderFormValues>();

    const [isDesktop] = useIsDesktop();

    return (
        <Controller
            control={control}
            defaultValue={formStore.belarusBirthLocality}
            name={BELARUS_BIRTH_LOCALITY_FORM_ITEM_NAME}
            rules={{ required: ValidationRules.required() }}
            render={({ field, fieldState }) => {
                return (
                    <SelectSearch<LocalityReference>
                        className={WEB_VISOR_HIDE}
                        componentRef={(element) => {
                            field.ref(element);
                            setFieldElement(
                                BELARUS_BIRTH_LOCALITY_FORM_ITEM_NAME,
                                element,
                            );
                        }}
                        isDesktop={isDesktop}
                        value={field.value}
                        optionKey={(value) => value.id}
                        selectedOptionTooltipRenderer={(value) => (
                            <PrimaryContent 
                                localityTypeStore={formStore.localityTypesStore}
                                localityReference={value}
                            />
                        )}
                        selectedOptionRenderer={(value) => (
                            <div>
                                <LocalityReferenceRenderer
                                    localityTypeStore={formStore.localityTypesStore}
                                    localityReference={value}
                                />
                            </div>
                        )}
                        optionRenderer={(value) => (
                            <LocalityReferenceRenderer
                                localityTypeStore={formStore.localityTypesStore}
                                localityReference={value}
                            />
                        )}
                        filter={(value) =>
                            new ReferenceService().getLocalitiesReference(value)
                        }
                        updateData={(value) =>
                            new ReferenceService().getLocalitiesReference(value)
                        }
                        error={handleMultipleErrors(fieldState.error)}
                        onBlur={(value) => {
                            field.onChange(value);
                            field.onBlur();
                        }}
                        label={'Населённый пункт'}
                        onChange={(locality) => {
                            field.onChange(locality);
                            formStore.setBelarusBirthLocality(locality);
                        }}
                    />
                );
            }}
        />
    );
};
